export const GET_FOLDERS_MATTERS_REQUEST = "GET_FOLDERS_MATTERS_REQUEST";
export const GET_FOLDERS_MATTERS_SUCCESS = "GET_FOLDERS_MATTERS_SUCCESS";
export const GET_FOLDERS_MATTERS_FAIL = "GET_FOLDERS_MATTERS_FAIL";